import React from "react";
import { FlexCol, BaseGrid } from "../generic/Containers";
import { BCPrimaryButton } from "../generic/BCButtons";
import { useGlobalState } from "../../GlobalState";

import TechCoursesImage from "../../images/toolkit-section/tech-courses.webp";
import MockInterviewsImage from "../../images/toolkit-section/mock-interviews.webp";
import InterviewStudyGuidesImage from "../../images/toolkit-section/interview-study-guides.webp";
import JobSearchingToolsImage from "../../images/toolkit-section/job-searching-tools.webp";
import InterviewPracticeImage from "../../images/toolkit-section/interview-practice.webp";
import PortfolioResourcesImage from "../../images/toolkit-section/portfolio-resources.webp";
import SupportedLanguagesImage from "../../images/toolkit-section/supported-languages.webp";

import "./ToolkitSectionComponent.css";
import {BCHeader2} from "../generic/BCHeaders";

interface ToolkitItem {
    image: string;
    label: string;
}

const toolkitItems: ToolkitItem[] = [
    { image: TechCoursesImage, label: "Real-World Tech Courses" },
    { image: MockInterviewsImage, label: "Mock Interviews" },
    { image: InterviewStudyGuidesImage, label: "Interview Study Guides" },
    { image: JobSearchingToolsImage, label: "Job Searching Tools" },
    { image: InterviewPracticeImage, label: "Coding Interview Practice" },
    { image: PortfolioResourcesImage, label: "Portfolio Building Resources" }
];

export const ToolkitSectionComponent: React.FC = () => {
    const { setShowAuthModal, setAuthModalMode } = useGlobalState();

    const handleJoinClick = () => {
        setAuthModalMode('register');
        setShowAuthModal(true);
    };

    return (
        <FlexCol className="toolkit-section-wrapper" align="center" gap={2} widthPercent={80} mTop={2} alignSelf={"center"}>
            <BCHeader2 text={"Your Complete Job-Ready Toolkit"} className="landing-section-header" />
            <FlexCol className="toolkit-section" align="center" gap={2} padding={2}>
                <BaseGrid columns={2} mobileColumns={1} tabletColumns={1} gap={1.5} widthPercent={100} >
                    {toolkitItems.map((item, index) => (
                        <div key={index} className="toolkit-card">
                            <div className="toolkit-card-image-container">
                                <img src={item.image} alt={item.label} className="toolkit-card-image" />
                            </div>
                            <span className="toolkit-card-label">{item.label}</span>
                        </div>
                    ))}
                </BaseGrid>

                <div className="toolkit-languages">
                    <span className="toolkit-languages-text">Any Platform, Any Language</span>
                    <img src={SupportedLanguagesImage} alt="Supported Languages" className="toolkit-languages-image" />
                </div>
            </FlexCol>

            {/*<BCPrimaryButton */}
            {/*    text="JOIN FOR FREE"*/}
            {/*    onClick={handleJoinClick}*/}
            {/*    className="landing-primary-cta-button"*/}
            {/*/>*/}
        </FlexCol>
    );
};
